import { useMutation } from '@tanstack/react-query'

import { UpdateClienteService } from '@/http/update-cliente.service'
import type { AxiosErrorMap } from '@/infra/http'
import type { TCreateCadastrarClienteData } from '@/types/cliente'
import { clienteKeys } from '@/utils/cliente-query-keys'

export const useMutationAtualizarCliente = () => {
  return useMutation<unknown, AxiosErrorMap, TCreateCadastrarClienteData & { id: string }>({
    retry: false,
    mutationKey: clienteKeys.atualizar(),
    mutationFn: async (params) => {
      const response = await new UpdateClienteService().execute(params.id, params)
      return response
    },
  })
}
